import { useEffect } from 'react'

function useRemoveBg(){
  useEffect(() => {
    const bodyTag = document.getElementsByTagName('body')[0]
    bodyTag.setAttribute("with-bg", 'false')
  }, [])
}

export default useRemoveBg